import { io } from 'socket.io-client';

const getBaseUrl = () => {
  const fullUrl = import.meta.env.VITE_API_URL;
  if (fullUrl && fullUrl.startsWith('http')) {
    const url = new URL(fullUrl);
    return `${url.protocol}//${url.hostname}:${url.port}`;
  }
  return window.location.origin;
};

let socket = null;

export const getSocket = () => socket;

export const connectSocket = (token) => {
  if (socket?.connected) return socket;

  if (socket) {
    socket.disconnect();
  }

  socket = io(getBaseUrl(), {
    auth: { token },
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  socket.on('connect', () => {
    console.log('[Socket] Conectado:', socket.id);
  });

  socket.on('disconnect', (reason) => {
    console.log('[Socket] Desconectado:', reason);
  });

  socket.on('connect_error', (error) => {
    console.error('[Socket] Error de conexión:', error.message);
  });

  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export default { getSocket, connectSocket, disconnectSocket };
